import React from 'react';

export const ServiceNowSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-67.5"
				y="-406.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="#292A2E" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.0629 5.33574C13.9175 5.33126 11.8203 5.97137 10.043 7.17308C8.2658 8.37478 6.89053 10.0827 6.09553 12.0753C5.30054 14.068 5.12247 16.2535 5.58441 18.3486C6.04636 20.4436 7.12701 22.3516 8.68629 23.8252C9.05202 24.1734 9.53035 24.3793 10.0347 24.4054C10.539 24.4316 11.0361 24.2764 11.4359 23.9679C12.7551 22.9862 14.3557 22.456 16.0001 22.456C17.6445 22.456 19.2451 22.9862 20.5643 23.9679C20.968 24.2771 21.4693 24.431 21.9769 24.4013C22.4846 24.3717 22.9647 24.1606 23.3296 23.8066C24.8767 22.3385 25.9501 20.4419 26.4122 18.3598C26.8743 16.2777 26.7041 14.105 25.9234 12.1203C25.1427 10.1355 23.7871 8.42916 22.0303 7.21988C20.2735 6.01061 18.1956 5.35353 16.0629 5.33289M16.0001 21.3839C15.295 21.4029 14.5934 21.2781 13.9381 21.0171C13.2828 20.756 12.6876 20.3642 12.1887 19.8655C11.6899 19.3668 11.2979 18.7716 11.0366 18.1164C10.7754 17.4612 10.6504 16.7596 10.6693 16.0545C10.6693 14.6407 11.2309 13.2848 12.2306 12.285C13.2304 11.2853 14.5863 10.7237 16.0001 10.7237C17.4139 10.7237 18.7698 11.2853 19.7696 12.285C20.7693 13.2848 21.3309 14.6407 21.3309 16.0545C21.3498 16.7596 21.2248 17.4612 20.9636 18.1164C20.7023 18.7716 20.3103 19.3668 19.8115 19.8655C19.3127 20.3642 18.7174 20.756 18.0621 21.0171C17.4068 21.2781 16.7052 21.4029 16.0001 21.3839Z"
				fill="#62D84E"
			/>
		</svg>
	);
};
